export const API_KEY = "_4ZfPALMDJr4V4YWgfDVoiu6WzhE_pVp5XckGlGNp8M";
export const API_URL = "https://api.unsplash.com"
export const API_SECRET = "u156M7wOoR1eKb9ekcuYTvuXvR1qTw1QyX1I7J6AyA8"